import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import SymptomCheckService from '../../services/symptom-check.service';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'symptom-check-introduction',
	templateUrl: './symptom-check-introduction.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class SymptomCheckIntroductionComponent implements OnInit {
	private symptomCheckService: SymptomCheckService = inject(SymptomCheckService);
	
	@Input() interview: any;
	@Output() interviewChange: EventEmitter<any> = new EventEmitter<any>();
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.handleSubmit = this.handleSubmit;
	}
	
	handleSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid) return;

		this.interviewChange.emit(this.vm.interview);
		this.symptomCheckService.nextStep();
	}
	
	goBack(e) {
		if (e && e.preventDefault) e.preventDefault();
		history.back();
	}
}